import { createSelector, createSlice } from "@reduxjs/toolkit"
import { filterService } from "../services/book/filter"

const initialState = {
  themeName: "default",
}

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      filterService.endpoints.getAviaFilterData.matchFulfilled,
      (state, action) => {
        const { theme_name } = action.payload
        state.themeName = theme_name || "default"
      }
    )
  },
})

const selectCommonState = (state) => state.common

export const {} = commonSlice.actions

export const selectThemeName = createSelector([selectCommonState], (state) => state.themeName)

export default commonSlice.reducer
